// extracted by mini-css-extract-plugin
export default {"confirmCarDeleteModal":"aYEYOb4T","heading":"_SgqICir","controls":"katwB_l2"};